export default (() => {
  const emptyPattern = /^\s*$/;

  const validate = data => {
    const invalid = data.some(cust => {
      if (emptyPattern.exec(cust.name)) return true;
      if (emptyPattern.exec(cust.label)) return true;
      if (cust.options !== undefined) {
        if (cust.options.length < 2) return true;
        if (!emptyPattern.exec(cust.options[0].price)) return true;
        const optsInvalid = cust.options.some(opt => {
          if (emptyPattern.exec(opt.value)) return true;
          return false;
        });
        if (optsInvalid) return true;
      }
      return false;
    });
    return !invalid;
  };

  return { validate: validate };
})();



// WEBPACK FOOTER //
// ./src/app/item-customisations/validator.js